"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboOfferDriverPrice = getComboOfferDriverPrice;
const getBasePriceFromTotalPrice_1 = require("../getBasePriceFromTotalPrice");
function getComboOfferDriverPrice(offer) {
    return (0, getBasePriceFromTotalPrice_1.getBasePriceFromTotalPrice)(offer.totalPrice) + offer.subsidy;
}
//# sourceMappingURL=getComboOfferDriverPrice.js.map